// Fichier : ViewUserTabs.tsx
// Ce fichier définit le composant ViewUserTabs qui utilise useGetUserTabsQuery pour récupérer les onglets d'un utilisateur en fonction de l'ID de l'utilisateur fourni dans les paramètres d'URL et affiche les onglets de l'utilisateur avec une barre latérale.

import { useGetTabsQuery, useGetUserTabsQuery } from "@/state/usersApiSlice"; // Importation de useGetUserTabsQuery pour interroger l'API des utilisateurs par ID et récupérer les onglets de l'utilisateur
import { useNavigate, useParams } from "react-router-dom"; // Importation de useParams de react-router-dom pour la récupération des paramètres d'URL
import { Checkbox } from "@/components/ui/checkbox";
import { useEffect, useState } from "react";
import styles from "./viewUserTabs.module.css";

const ViewUserTabs = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Récupération de l'ID de l'utilisateur à partir des paramètres d'URL
  console.log("User ID:", id);

  // Utilisation de useGetUserTabsQuery pour interroger l'API et récupérer les données des onglets de l'utilisateur en fonction de l'ID
  // Affichage d'un message de chargement pendant le chargement des données des onglets de l'utilisateur

  const { data, isLoading, isError } = useGetTabsQuery(); // Requête pour obtenir la liste des Tabs.
  const {
    data: userTabs,
    isLoading: userLoading,
    isError: userError,
  } = useGetUserTabsQuery(id); // Requête pour obtenir les onglets de l'utilisateur (basé sur l'ID de l'utilisateur)

  // État pour suivre les onglets cochés ou décochés
  const [checkedTabs, setCheckedTabs] = useState<number[]>([]);

  useEffect(() => {
    // useEffect pour initialiser les onglets cochés basés sur les Tabs de l'utilisateur
    if (userTabs) {
      const initialCheckedTabs = userTabs.tabs.map(
        (userTab: any) => userTab.tabId
      );
      setCheckedTabs(initialCheckedTabs);
    }
  }, [userTabs]); // Avec la dependance "userTabs" , cette useEffect va se déclencher et modifier "CheckedTabs" par les Tabs actives pour l'utilisateur donné.

  // Affichage conditionnel en fonction de l'état de la requête
  if (isLoading || userLoading) {
    return <div>Loading...</div>; // Afficher un message de chargement
  }

  if (isError || userError) {
    return <div>Error loading data.</div>; // Afficher un message d'erreur
  }

  return (
    <div className={styles.container}>
      <div className={styles["grid-container"]}>
        {/* Itération sur les Tabs pour afficher les cases à cocher */}
        {data.map((tab: any) => (
          <div className={styles["form-container"]} key={tab.id}>
            <Checkbox
              id={tab.id}
              name={tab.tab_name}
              checked={checkedTabs.includes(tab.id)}
              disabled
            />
            <label htmlFor={tab.id}>{tab.tab_name}</label>
          </div>
        ))}
      </div>
      <div className={styles.buttonsContainer}>
        <button
          className={styles.button}
          onClick={() => navigate(`/users/${id}/tabs/edit`)}
        >
          Edit Tabs
        </button>
      </div>
    </div>
  );
};

export default ViewUserTabs;
